import axios from 'axios';

export function getProfile(userId) {
  if (userId) {
    return axios.get(`/profile/${userId}`)
  } else {
    return axios.get('/profile');
  }
}

export function sendForgotPassword(payload) {
  return axios.post(`user/forgot-password`, payload);
}

export function sendPasswordReset(payload) {
  return axios.post(`user/reset-password`, payload);
}

export function sendPasswordSet(payload) {
  return axios.post(`user/password`, payload);
}

export function newBusiness(payload) {
  return axios.post(`user/business`, payload);
}

export function updateBusiness(payload) {
  return axios.put(`user/business`, payload);
}

export function updateSeenUpdates() {
  return axios.put(`user/seenUpdates`);
}

export function setDefaultBusiness(payload) {
  return axios.post(`user/business/default`, payload);
}

export function removeBusiness(businessId) {
  return axios.delete(`user/business/${businessId}`);
}

export function getBusinesses() {
  return axios.get('user/business');
}

export function getRatings() {
  return axios.get(`/project/user/ratings`);
}

export function updateEmail(email) {
  return axios.put(`/user/email`, email);
}

export function updatePhoneCode(phoneCode) {
  return axios.put(`/user/phoneCode`, phoneCode);
}

export function updatePhone(phone) {
  return axios.put(`/user/phone`, phone);
}

export function changeRoles(active_roles) {
  return axios.post('/change-role', {
    roles: active_roles
  });
}

export function acceptTerms(hasAccepted) {
  return axios.put('/terms-of-use/accepted', {
    hasAccepted: hasAccepted
  });
}

export function toggleEmailEnabled() {
  return axios.put('/user/emailEnabled');
}
export function toggleProfileHidden() {
  return axios.put('/user/profileHidden');
}

export function updateContactInfo(params) {
  return axios.post('/profile/email', params);
}

export function getSoftware() {
  return axios.get("/software");
}

export function updateSoftware(payload) {
  return axios.post("/software", payload);
}

export function updateSecondaryAreas(payload) {
  return axios.put("/user/secondaryArea", payload);
}

export function getQualifications() {
  return axios.get("/user/qualification");
}

export function getNotifications() {
  return axios.get("/user/notification");
}